import { useTypedApiClient } from 'hooks/useTypedApiClient'
import { useMutation, useQueryClient } from '@tanstack/react-query'

interface UseDeleteSweepstakeParams {
  id: number | null | undefined
}

interface UseDeleteSweepstakeProps {
  onSuccess?: (data: undefined, variables: UseDeleteSweepstakeParams) => void
  onError?: (error: Error, variables: UseDeleteSweepstakeParams) => void
  invalidateSweepstakesQuery?: boolean
}

export const useDeleteSweepstakeById = ({
  onSuccess,
  onError,
  invalidateSweepstakesQuery = true,
}: UseDeleteSweepstakeProps) => {
  const deleteSweepstake = useTypedApiClient({
    path: '/admin/contests/{id}',
    method: 'delete',
  })
  const queryClient = useQueryClient()

  return useMutation<any, Error, UseDeleteSweepstakeParams>({
    mutationFn: async ({ id }: UseDeleteSweepstakeParams) => {
      await deleteSweepstake({ id: Number(id) })
    },
    onSuccess: async (data, variables) => {
      if (invalidateSweepstakesQuery) {
        await queryClient.invalidateQueries({
          queryKey: ['/sweepstakes'],
        })
      }
      onSuccess?.(data, variables)
    },
    onError,
  })
}
